import React from 'react';
import {useQuery} from 'react-query';
import {QUERY_KEYS} from '../../../constants';
import styles from './styles.module.scss';
import Item from './item';
import Title from 'components/typografy/title';
import {getVendorsData} from 'api/payment';
import {IVendor, IVendorNames} from 'types/payment';
import SkeletonItem from './skeleton';
import NoData from 'components/no-data';

const List: React.FC = () => {
  const {data: resultData = {}, isFetching} = useQuery<Record<IVendorNames, IVendor>>(
    [QUERY_KEYS.CASHOUT.VENDORS_DATA],
    async () => {
      return await getVendorsData();
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false
    }
  );

  const vendorsList = Object.values(resultData) as IVendor[];
  return (
    <div className={styles.wrapper}>
      <Title variant={'h2'}>
        <>Cashout Options</>
      </Title>
      <div className={styles.row}>
        {isFetching ? (
          [1, 2, 3, 4].map((item: number) => {
            return <SkeletonItem key={item} />;
          })
        ) : vendorsList?.length > 0 ? (
          vendorsList.map((vendor, index) => {
            return (
              <Item
                title={vendor.displayName}
                bonus={vendor.bonus}
                type={vendor.name}
                image={vendor.image}
                maxPrice={vendor.priceRange.max}
                minPrice={vendor.priceRange.min}
                key={index}
              />
            );
          })
        ) : (
          <NoData />
        )}
      </div>
    </div>
  );
};

export default List;
